<template>
  <div class="apple-button-wrapper">
    <button class="apple-button social-button" @click="submit">
      <img src="@/assets/images/SignIn/apple.svg" alt="Apple" />
    </button>
  </div>
</template>

<script>
import './styles.scss'

import {
  APPLE_CLIENT_ID,
  needsExplicitRedirectUri,
  resolveAppleRedirectUri,
  appleSubFromIdToken,
  savePendingAppleUser,
  loadPendingAppleUser,
  clearPendingAppleUser
} from '@/utils/appleAuth'

const SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ru_RU/appleid.auth.js'

export default {
  name: 'AppleButton',

  computed: {
    redirectUri() {
      return resolveAppleRedirectUri(window.location.origin)
    }
  },
  mounted() {
    this.loadAppleSDK()
  },

  methods: {
    loadAppleSDK() {
      if (document.querySelector(`script[src="${SDK_URL}"]`)) {
        this.initAppleSDK()
        return
      }

      const script = document.createElement('script')
      script.src = SDK_URL
      script.async = true
      script.defer = true
      script.onload = this.initAppleSDK
      document.body.appendChild(script)
    },

    initAppleSDK() {
      if (!window.AppleID) return

      window.AppleID.auth.init({
        clientId: APPLE_CLIENT_ID,
        scope: 'name email',
        redirectURI: this.redirectUri,
        usePopup: true
      })
    },

    async loginViaApple(code, user, idToken) {
      // Имя юзера Apple присылает единственный раз (первый вход) — страхуем
      // его в localStorage до успешного входа, см. utils/appleAuth.js
      const appleSub = appleSubFromIdToken(idToken)
      if (user && appleSub) {
        savePendingAppleUser(appleSub, user)
      }

      try {
        const body = { code, user: user || loadPendingAppleUser(appleSub) }

        // На дев-фронте (и любом не-дефолтном адресе) бэку нужно передать тот
        // же redirect_uri, с которым прошёл init, иначе Apple → invalid_grant
        if (needsExplicitRedirectUri(this.redirectUri)) {
          body.redirect_uri = this.redirectUri
        }

        const response = await fetch('https://users.backend-pier.com/api/v1/user/login-apple', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })

        const data = await response.json()

        if (data.auth_token && data.data) {
          clearPendingAppleUser()
          this.$store.dispatch('signIn', data)

          // Устанавливаем валюту и язык из ответа бэкенда
          if (data.data.currency) {
            this.$store.commit('setCurrency', data.data.currency.toLowerCase())
          }
          if (data.data.language) {
            this.$store.commit('setLanguage', data.data.language.toLowerCase())
          }

          if (this.$analytics) {
            this.$analytics.send('login', {
              type: 'login',
              method: 'apple',
              user_id: data.data?.user_id
            })
            this.$analytics.setUser(data.data?.user_id)
          }

          // Эмитим событие успешной авторизации родительскому компоненту
          this.$emit('auth-success', data)
        } else {
          console.error('Apple auth failed:', data)
          this.notifyError()
        }
      } catch (error) {
        console.error('Error during Apple authentication:', error)
        this.notifyError()
      }
    },

    notifyError() {
      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.warning'),
        description: this.$t('auth.errors.social'),
        type: 'error'
      })
    },

    async submit() {
      if (!window.AppleID) return

      try {
        const res = await window.AppleID.auth.signIn()

        // Имя Apple отдаёт ТОЛЬКО при самом первом входе юзера — пробрасываем,
        // иначе он зарегается с именем из почты.
        this.loginViaApple(res?.authorization?.code, res?.user, res?.authorization?.id_token)
      } catch (error) {
        // Юзер закрыл окно Apple — это не ошибка
      }
    }
  }
}
</script>
